let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("ff9v5")]).then(() => parcelRequire('2B8HF'));